import { gql } from "@apollo/client";

export default gql`
query {
  globalSet (handle: "subscribeForm") {
    ...on subscribeForm_GlobalSet {
      subscribeForm {
        ...on subscribeFormBlock_Entry {
          beforeSelectorText
          adultText
          studentText
          fieldText
          disclaimerText
          loadingText
          successText
          signUpNowText
          downloadNowText
          signUpText
        }
      }
    }
  }
}
`;
